import { createApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { environment } from '../environments/environment';
import { createCustomElement } from '@angular/elements';
import { ENVIRONMENT } from '@helsana/data-access';
import { provideNoopLocationStrategy } from './noop-location-strategy';

export const provideWebComponent = async (
  selector: string,
  outlet: string,
  routerComponent: any,
  wrapperComponent: any,
  environmentProvider: Function
) => {
  const app = await createApplication({
    providers: [
      provideRouter([
        {
          path: '',
          outlet: outlet,
          component: routerComponent
        }
      ]),
      environmentProvider(),
      provideNoopLocationStrategy(),
      { provide: ENVIRONMENT, useValue: environment },
    ]
  });

  const WebComponent = createCustomElement(wrapperComponent, {
    injector: app.injector
  });

  if (!customElements.get(selector)) {
    customElements.define(selector, WebComponent);
  }
};
